export default {
	title: '项目组合',
	description: '我的全部 Gerositus 项目',
	actions: {
		back_to_this: '返回项目组合'
	},
	search_projects: '搜索项目',
	cta: {
		welcome: '欢迎并感谢您使用 Gerositus Strategy Suite！',
		subscribe: '立即订阅',
		create_permission: '即可创建新项目。'
	},
	tabs: {
		risks: {
			title: '风险与机会设置'
		}
	}
};
